/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'components/Pagination';
import { useHistory } from 'react-router-dom';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';
import ConfigurationService from '../../SystemParams/services';

import {
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  Input,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import SimpleHeader from '../../../components/Headers/SimpleHeader';
import ReactLoader from 'components/Loader';

import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../assets/styles/table_custom_style';

const ChatGPTConfigList = () => {
  const history = useHistory();

  const [list, setList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [id, setId] = useState();

  const getData = () => {
    ConfigurationService.getAIConfigSearch()
      .then((response) => {
        setLoading(false);
        setList(response?.data.data ?? []);
        setQuantity(response?.data?.pagination?.totalRecords ?? 0);
      })
      .catch((error) => {
        if (error.response) {
          toast.error('Erro ao carregar Dados!', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
      });
  };

  const controlDelete = (id) => {
    setId(id);
    setOpenModalConfirmation(true);
  };

  const handleDelete = (id) => {
    ConfigurationService.deleteAIConfig(id)
      .then(() => {
        toast.success('Excluido com sucesso!', {
          autoClose: 3000,
          closeOnClick: true
        });
        getData();
      })
      .catch((err) => {
        const { message } = err.response.data;
        toast.error(message, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setId();
        setOpenModalConfirmation(false);
      });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (selectedPage = 1, querySearch = '') => {
    ConfigurationService.getAIConfigSearch(10, selectedPage, querySearch)
      .then((res) => {
        const data = res.data.data;
        const totalRegisters = res.data.pagination.totalRecords;
        const newActivePage = selectedPage || activePage;
        setQuantity(totalRegisters);
        setActivePage(newActivePage);
        setList(data);
        setLoading(false);
      })
      .catch(() => {
        toast.error('Não foi possível listar configurações', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handlePageChange = (activePage) => handleSearch(activePage);

  const handleUpdate = ({ id }) => {
    console.log('id: ', id);
    history.push(`/admin/chat/IAconfiguration/form/${id}`);
  };

  const handleOnSearch = (event) => {
    const q = event.target.value;
    setTimeout(() => {
      handleSearch(1, q);
    }, 500);
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/chat/IAconfiguration/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">ChatGPT - OpenAI</h3>
                </CardHeader>

                <Row className="mt-3 mx-2">
                  <Col md="8">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Busca por nome"
                        type="text"
                        defaultValue=""
                        onChange={handleOnSearch}
                      />
                    </InputGroup>
                  </Col>
                  {/* <Col md="4" className="text-right mt-2 mt-md-1">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={showDisabled}
                          onChange={() => setShowDisable(!showDisabled)}
                        />
                        <span>Mostar desabilitados</span>
                      </Label>
                    </FormGroup>
                  </Col> */}
                </Row>

                <ToolkitProvider
                  data={list}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name_channel',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'model',
                      text: 'Modelo',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'project_id',
                      text: 'Project Id',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'assintant_id',
                      text: 'Assistant Id',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    // {
                    //   dataField: 'ativado',
                    //   text: 'Ativo',
                    //   sort: true,
                    //   style: individual_column_style,
                    //   headerStyle: individual_header_style,
                    //   formatter: (_, row) => {
                    //     return (
                    //       <ChipContainer>
                    //         {row.ativado === true ? (
                    //           <Chip
                    //             className="chipTrue"
                    //             size="small"
                    //             label="sim"
                    //           />
                    //         ) : (
                    //           <Chip
                    //             className="chipFalse"
                    //             size="small"
                    //             label="não"
                    //           />
                    //         )}
                    //       </ChipContainer>
                    //     );
                    //   }
                    // },

                    // {
                    //   dataField: 'disable',
                    //   style: icon_column_style,
                    //   headerStyle: individual_icon_header_style_callback,
                    //   text: 'Desabilitar / Habilitar',
                    //   // eslint-disable-next-line react/display-name
                    //   formatter: (_, row) => {
                    //     return (
                    //       <div
                    //         onClick={() => {
                    //           toggleDisable(row);
                    //         }}
                    //       >
                    //         <ToggleSwitch checked={row.ativado} id={row.name} />
                    //       </div>
                    //     );
                    //   }
                    // },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            // outline
                            type="button"
                            size="sm"
                            disabled={row.disable}
                            onClick={() => handleUpdate(row)}
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="danger"
                            onClick={() => controlDelete(row.id)}
                            size="sm"
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
        <ModalConfirmation
          isModalOpen={openModalConfirmation}
          onModalToggle={setOpenModalConfirmation}
          unmountOnClose={true}
          idResource={id}
          deleteResource={handleDelete}
          message={'Tem certeza que deseja excluir a configuração?'}
        />
      </Container>
    </>
  );
};

export default ChatGPTConfigList;
